import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { api } from "../utils/axios-instance";
import toast from "react-hot-toast";

const MailCallback = () => {
  const { provider } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [effectiveProvider, setEffectiveProvider] = React.useState(provider || "google");

  useEffect(() => {
    const handleCallback = async () => {
      // If provider is not in URL, check state from hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const state = params.get("state");
      const currentProvider = provider || (state === "gmail" ? "google" : "google");
      
      try {
        setEffectiveProvider(currentProvider);
        const accessToken = params.get("access_token");

        if (!accessToken) {
          toast.error(`Failed to get ${currentProvider} access token`);
          navigate("/dashboard");
          return;
        }

        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        const clientSecret = process.env.REACT_APP_GOOGLE_CLIENT_SECRET;

        // Send to backend
        const endpoint = "/users/google_login/";
        
        await api.post(endpoint, {
          token: accessToken,
          clientId,
          clientSecret,
          provider: currentProvider
        });

        toast.success(`Gmail connected successfully!`);
        navigate("/dashboard");
      } catch (err) {
        console.error(`Error during ${currentProvider} callback:`, err);
        toast.error(`Failed to connect ${currentProvider}`);
        navigate("/dashboard");
      }
    };

    handleCallback();
  }, [provider, location, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="h6">
        Finishing connection to Gmail...
      </Typography>
    </Box>
  );
};

export default MailCallback;
